import React from "react";

const ValuesSection = () => {
  return (
    <div className="bg-gradient-to-b from-blue-100 to-white">
      <div className="relative max-w-[1280px] mx-auto md:block hidden px-4 py-12 text-center h-[750px] overflow-y-scroll hide-scrollbar">
        {/* Header Section */}
        <h3 className="small:text-2xl text-webOranage font-medium">
        Our Commitment
        </h3>
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mt-2">
        Driving Success 
        <br /> Through Core Values
        </h2>

        {/* Large Outlined Words - Each text inside a relative div */}
        <div className="relative mt-16 text-center space-y-20">
          {/* Collaboration */}
          <div className="relative">
            <h1 className="value-heading">Collaboration</h1>
            <div className="bubble top-[-20px] right-[15%] bg-webOranage">
            Working together <br /> to achieve more.
            </div>
          </div>

          {/* Continuous Learning */}
          <div className="relative">
            <h1 className="value-heading">Growth</h1>
            <div className="bubble top-[0px] left-[50%] bg-secondary text-white">
            Evolving through <br /> learning and innovation. 
            </div>
          </div>

          {/* Transparency */}
          <div className="relative">
            <h1 className="value-heading">Transparency</h1>
            <div className="bubble top-[-25px] right-[12%] bg-webOranage">
            Open communication <br /> for trust and clarity.
            </div>
          </div>

          {/* Scalability */}
          <div className="relative">
            <h1 className="value-heading">Scalability</h1>
            <div className="bubble -top-[10%] left-[40%] bg-secondary text-white">
            Building flexible <br /> and future-ready solutions.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValuesSection;
